<template>
  <v-flex xs12 sm8 md6 class="main-col">
    <p class="gotham-m guide-title" transition="scale-transition">Libratone BIRD</p>
    <p class="gotham-m guide-desc">{{ $t('t4') }}</p>
    <v-card class="lbt-card">
      <v-card-media v-bind:src="require('../images/bird/cover.jpg')" height="270px"></v-card-media>
      <v-card-title primary-title class="card-content" :style="{ marginTop: 0 }">
        <ul id="menu">
          <li @click="$vuetify.goTo('#download')">
            {{ $t('t7') }}
          </li>
          <li @click="$vuetify.goTo('#interface')">
            {{ $t('t8') }}
          </li>
          <li @click="$vuetify.goTo('#power_on')">
            {{ $t('t9') }}
          </li>
          <li @click="$vuetify.goTo('#connect')">
            {{ $t('t10') }}
          </li>
          <li @click="$vuetify.goTo('#assistant')">
            {{ $t('t11') }}
          </li>
          <li @click="$vuetify.goTo('#basic_operation')">
            {{ $t('t12') }}
          </li>
          <li @click="$vuetify.goTo('#indicator_light')">
            {{ $t('t13') }}
          </li>
          <li @click="$vuetify.goTo('#plus1')">
            {{ $t('t14') }}
          </li>
          <li @click="$vuetify.goTo('#magnetic_design')">
            {{ $t('t15') }}
          </li>
          <li @click="$vuetify.goTo('#faq')">
            {{ $t('t16') }}
          </li>
          <li @click="$vuetify.goTo('#spec')">
            {{ $t('t17') }}
          </li>
        </ul>
      </v-card-title>
    </v-card>
    <!--下载-->
    <v-card id="download" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t18' )}}</p>
        <p class="lbt-content">{{ $t('t19') }}</p>
        <v-layout row justify-center align-center>
          <v-flex xs8>
            <v-layout column align-center>
              <img class="qr-pic" src="../images/qr_download.png">
              <v-btn class="lbt-button" href="http://download.birdytone.com.cn/index.html">Download</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>
    </v-card>
    <!--按键及接口说明-->
    <v-card id="interface" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t20' )}}</p>
        <img src="../images/bird/interface01.png" class="full-pic"/>
        <p class="lbt-content">{{ $t('t21') }}</p>
      </v-card-title>
    </v-card>
    <!--开关机-->
    <v-card id="power_on" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t22' )}}</p>
        <img src="../images/bird/power_on01.gif" class="full-pic"/>
        <p class="lbt-content">{{ $t('t23') }}</p>
      </v-card-title>
    </v-card>
    <!--连接-->
    <v-card id="connect" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t24' )}}</p>
        <p class="lbt-content-dark">{{ $t('t25') }}</p>
        <p class="lbt-content-flex"><img src="../images/bird/connect01.gif" />{{ $t('t26') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t27' )}}</p>
        <p class="lbt-content-flex"><img src="../images/bird/connect02.png" />{{ $t('t28') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t29' )}}</p>
        <p class="lbt-content-flex"><img src="../images/bird/connect03.gif" />{{ $t('t30') }}</p>
      </v-card-title>
    </v-card>
    <!--语音助手-->
    <v-card id="assistant" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t31' )}}</p>
        <p class="lbt-content-flex"><img src="../images/bird/assistant03.png" />{{ $t('t32') }}</p>
        <div v-if="lang === '简体中文'">
          <div class="hairline"></div>
          <p class="lbt-content-flex"><img src="../images/bird/assistant02a.png" />{{ $t('t33') }}</p>
          <p class="lbt-content-light">{{ $t('t34') }}<br/><br/>{{ $t('t35') }}</p>
        </div>
      </v-card-title>
    </v-card>
    <!--基本操作-->
    <v-card id="basic_operation" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t36' )}}</p>
        <p class="lbt-content-dark">{{ $t('t37') }}</p>
        <p class="lbt-content-flex"><img src="../images/bird/basic_operation01.png" />{{ $t('t38') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t39' )}}</p>
        <p class="lbt-content-flex"><img src="../images/bird/basic_operation02.png" />{{ $t('t40') }}<br/><br/>{{ $t('t41') }}</p>
      </v-card-title>
    </v-card>
    <!--状态指示-->
    <v-card id="indicator_light" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t42') }}</p>
        <p class="lbt-content-dark">{{ $t('t43') }}</p>
        <p class="lbt-content-flex"><img src="../images/bird/indicator_light01.gif" />{{ $t('t44') }}</p>
        <p class="lbt-content-flex"><img src="../images/bird/indicator_light02.gif" />{{ $t('t45') }}</p>
        <p class="lbt-content-flex"><img src="../images/bird/indicator_light03.gif" />{{ $t('t46') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t47') }}</p>
        <p class="lbt-content-flex"><img src="../images/bird/indicator_light04.png" />{{ $t('t48') }}</p>
        <p class="lbt-content-flex"><img src="../images/bird/indicator_light05.gif" />{{ $t('t49') }}</p>
        <p class="lbt-content-flex"><img src="../images/bird/indicator_light06.png" />{{ $t('t50') }}</p>
      </v-card-title>
    </v-card>
    <!--plus1-->
    <v-card id="plus1" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t51') }}</p>
        <p class="lbt-content-dark">{{ $t('t52') }}</p>
        <p class="lbt-content-flex"><img src="../images/bird/plus101.png" />{{ $t('t53') }}</p>
        <p class="lbt-content-flex"><img src="../images/bird/plus102.png" />{{ $t('t54') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t55') }}</p>
        <p class="lbt-content-flex"><img src="../images/bird/plus103.png" />{{ $t('t56') }}</p>
      </v-card-title>
    </v-card>
    <!--磁吸设计-->
    <v-card id="magnetic_design" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t57') }}</p>
        <p class="lbt-content-dark">{{ $t('t58') }}</p>
        <p class="lbt-content-flex"><img src="../images/bird/magnet01.png" />{{ $t('t59') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t60') }}</p>
        <p class="lbt-content-flex"><img src="../images/bird/magnet02.png" />{{ $t('t61') }}</p>
        <p class="lbt-content-light">{{ $t('t62') }}<br/><br/>{{ $t('t63') }}</p>
      </v-card-title>
    </v-card>
    <!--常见问题-->
    <v-card id="faq" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t64' )}}</p>
        <p class="lbt-content-dark">{{ $t('t65') }}</p>
        <p class="lbt-content">{{ $t('t66') }}</p>
        <p class="lbt-content">{{ $t('t67') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t68') }}</p>
        <p class="lbt-content">{{ $t('t69') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t70') }}</p>
        <p class="lbt-content">{{ $t('t71') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t72') }}</p>
        <p class="lbt-content">{{ $t('t73') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t74') }}</p>
        <p class="lbt-content">{{ $t('t75') }}</p>
        <p class="lbt-content-light">{{ $t('t76') }}</p>
      </v-card-title>
    </v-card>
    <!--产品参数-->
    <v-card id="spec" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t77' )}}</p>
        <p class="lbt-content-dark">{{ $t('t78') }}</p>
        <p class="lbt-content">{{ $t('t79') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t80') }}</p>
        <p class="lbt-content">{{ $t('t81') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t82') }}</p>
        <p class="lbt-content">{{ $t('t83') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t84') }}</p>
        <p class="lbt-content">{{ $t('t85') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t86') }}</p>
        <p class="lbt-content">{{ $t('t87') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t88') }}</p>
        <p class="lbt-content">{{ $t('t89') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t90') }}</p>
        <p class="lbt-content">{{ $t('t91') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t92') }}</p>
        <p class="lbt-content">{{ $t('t93') }}</p>
      </v-card-title>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: 'Content',
  props: ['lang']
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/bird/content.vue